// Remove "What You'll Need" if no featured product is available
(() => {
  const featuredSection = document.querySelector('.shopify-section[id*="featured_product"]');

  if (!featuredSection) {
    return;
  }

  const richTextSection = featuredSection.previousElementSibling;

  if (richTextSection?.firstChild?.textContent.trim() !== 'sections/text.liquid') {
    return;
  }

  if (!featuredSection.firstElementChild) {
    richTextSection.remove();
  }
})();
